import React from "react";
import { styled, css } from "styled-components";
import Colors from "../../styles/Colors";
import rem from "../../utils/rem";
const StyledTooltip = styled.div `
  background: ${Colors.GRAY_DARKEST};
  color: ${Colors.WHITE};
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  padding: ${rem(24)} ${rem(30)};
  font-size: ${rem(16)};
  font-weight: normal;
  line-height: ${rem(24)};
  width: 100%;

  ${({ length }) => length === "fixed" &&
    css `
      max-width: ${rem(320)};
    `}
  ${({ position, absolute, transformToParent }) => position &&
    css `
      position: ${absolute ? "absolute" : "fixed"};

      ${position === "top-left" &&
        css `
        top: 0;
        left: 0;
        ${transformToParent &&
            css `
          transform: translateY(calc(-100% - 4px));
        `}
      `}
      ${position === "top-right" &&
        css `
        top: 0;
        right: 0;
        ${transformToParent &&
            css `
          transform: translateY(calc(-100% - 4px));
        `}
      `}
    ${position === "bottom-left" &&
        css `
        bottom: 0;
        left: 0;
        ${transformToParent &&
            css `
          transform: translateY(calc(100% + 4px));
        `}
      `}
    ${position === "bottom-right" &&
        css `
        bottom: 0;
        right: 0;
        ${transformToParent &&
            css `
          transform: translateY(calc(100% + 4px));
        `}
      `}
    `}
`;
export const Tooltip = React.forwardRef(({ children, position, transformToParent, absolute, length = "fullwidth" }, ref) => (React.createElement(StyledTooltip, { tabIndex: -1, ref: ref, transformToParent: transformToParent, position: position, length: length, absolute: absolute }, children)));
export default Tooltip;
//# sourceMappingURL=Tooltip.js.map